import { useState, useMemo } from 'react'
import type { CaseDocument } from '../../../hooks/useCase'

export interface UseDocumentFiltersResult {
  searchQuery: string
  setSearchQuery: (query: string) => void
  filteredDocuments: CaseDocument[]
}

export function useDocumentFilters(documents: CaseDocument[] | undefined): UseDocumentFiltersResult {
  const [searchQuery, setSearchQuery] = useState('')

  // Filter documents by search query
  const filteredDocuments = useMemo(() => {
    if (!documents) return []
    if (!searchQuery.trim()) return documents
    const query = searchQuery.toLowerCase()
    return documents.filter(doc =>
      doc.filename.toLowerCase().includes(query) ||
      doc.document_type?.toLowerCase().includes(query)
    )
  }, [documents, searchQuery])

  return {
    searchQuery,
    setSearchQuery,
    filteredDocuments,
  }
}

